<template>
  <div>
    <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
      y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
      <g id="进击盒弹大作战">
        <g id="编组-31">
          <path id="形状结合" class="st0" d="M8,0c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S3.6,0,8,0z"
            :fill="color || cc.theme_color" />
          <path id="形状结合_1_" :fill="bg || '#FFFFFF'" class="st1" d="M10.6,4.2L10.6,4.2c0.3,0.3,0.4,0.7,0.1,1l-0.1,0.1L9.4,6.5l0.8,0
            c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.6,0.7l-0.1,0H8.7v0.7l1.5,0c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.6,0.7l-0.1,0l-1.5,0
            l0,1.5c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.6l0-0.1l0-1.5l-1.5,0c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.6-0.7l0.1,0
            l1.5,0V8H5.8C5.4,8,5.1,7.7,5.1,7.3c0-0.4,0.3-0.7,0.6-0.7l0.1,0l0.8,0L5.3,5.2C5,5,5,4.5,5.3,4.2C5.6,4,6,3.9,6.3,4.2l0.1,0.1
            L8,5.9l1.7-1.7C9.9,4,10.3,3.9,10.6,4.2z" />
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    cc: {
      type: Object,
      default: () => { }
    },
    color: {
      type: String,
      default:''
    },
    bg: {
      type: String,
      default:''
    },
    reverse: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="less">
// .st0 {
//   fill: #6B61FF;
// }

.st1 {
  // fill: #FFFFFF;
}
</style>